import { render, staticRenderFns } from "./PurchasePrintComponent.vue?vue&type=template&id=e5f2487e"
import script from "./PurchasePrintComponent.vue?vue&type=script&lang=js"
export * from "./PurchasePrintComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports